module.exports = __webpack_public_path__ + "static/media/watch4.cd23a26d.jpg";